import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart7: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChart7"><Path d="M4.5 3.00098L4.5 1.00098H3L3 23.001H4.5L4.5 21.001H20.999V16.001L4.5 16.001V14.501H15.499V9.50098H4.5V8.00098L9.99902 8.00098V3.00098L4.5 3.00098Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart7;
